// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oW8Z","question":"styles_question__3TRCt","description":"styles_description__9K4YN"};